<template>
  <component
    :is="href ? 'a' : 'div'"
    class="tw-border-2 !tw-no-underline tw-transition-all tw-ease-in-out tw-border-solid tw-font-poppins tw-font-semibold tw-rounded-lg tw-cursor-pointer tw-inline-block tw-relative"
    :class="[sizeClass, variantClass, customStyle]"
    :target="target"
    :href="href"
    @click="onClick"
  >
    <div
      v-if="loading"
      class="tw-flex tw-items-center tw-justify-center tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full"
    >
      <div class="tw-w-8 tw-h-8">
        <LoadingIcon :color="iconColor" class="w-6" />
      </div>
    </div>
    <div
      class="tw-h-full tw-flex tw-items-center"
      :class="{ 'tw-opacity-0': loading }"
    >
      <div class="tw-w-full"><slot /></div>
    </div>
  </component>
</template>
<script>
import LoadingIcon from '@/components/v3/base/LoadingIcon';

export default {
  components: {
    LoadingIcon,
  },

  props: {
    size: {
      type: String,
      default: 'medium',
    },

    variant: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    href: {
      type: String,
      default: '',
    },

    target: {
      type: String,
      default: '',
    },

    customStyle: {
      type: String,
      default: '',
    },
  },

  computed: {
    sizeClass() {
      let result = '';
      switch (this.size) {
        case 'xl':
          result = 'tw-text-2xl tw-leading-9 tw-px-6 tw-py-2.5 tw-h-[76px]';
          break;

        case 'large':
          result = 'tw-text-lg tw-leading-7 tw-px-4 tw-py-2.5 tw-h-[52px]';
          break;

        case 'small':
          result = 'tw-text-sm tw-leading-5 tw-px-3 tw-py-1.5 tw-h-[38px]';
          break;

        default:
          result = 'tw-text-sm tw-leading-5 tw-px-3.5 tw-py-2.5 tw-h-[44px]';
          break;
      }
      return result;
    },

    variantClass() {
      let result = '';
      switch (this.variant) {
        case 'outlined':
          result = 'tw-border-purple-600 !tw-text-purple-600';
          if (this.disabled) result += ' tw-opacity-30  !tw-cursor-default';
          else
            result +=
              ' hover:tw-bg-purple-100 active:tw-border-purple-900 active:tw-text-purple-900';
          break;

        case 'gray':
          result =
            'tw-border-gray-700 !tw-text-white tw-bg-gray-700 hover:tw-bg-gray-800 hover:tw-border-gray-800 active:tw-bg-gray-900 active:tw-border-gray-900 button button--grey';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;
        case 'gray-8':
          result =
            'tw-border-gray-800 !tw-text-white tw-bg-gray-800 hover:tw-bg-gray-900 hover:tw-border-gray-900 active:tw-bg-gray-900 active:tw-border-gray-900 button button--grey';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;

        case 'black':
          result =
            'tw-border-gray-900 !tw-text-white tw-bg-gray-900 hover:tw-bg-gray-800 hover:tw-border-gray-800 active:tw-bg-gray-900 active:tw-border-gray-900 button button--grey';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;

        case 'danger':
          result =
            'tw-border-red-700 !tw-text-white tw-bg-red-700 hover:tw-bg-red-800 hover:tw-border-red-800 active:tw-bg-red-900 active:tw-border-red-900';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;
        case 'danger2':
          result =
            'tw-border-red-600 !tw-text-white tw-bg-red-600 hover:tw-bg-red-500 hover:tw-border-red-500 active:tw-bg-red-900 active:tw-border-red-900';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;
        case 'approve':
          result =
            'tw-border-green-600 !tw-text-white tw-bg-green-600 hover:tw-bg-green-500 hover:tw-border-green-500 active:tw-bg-green-900 active:tw-border-green-900';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;
        case 'danger-outlined':
          result =
            'tw-border-red-700 !tw-text-red-700 hover:!tw-text-white hover:tw-bg-red-800 hover:tw-border-red-800 active:tw-bg-red-900 active:tw-border-red-900';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;

        case 'text':
          result =
            'hover:tw-text-gray-600 active:tw-bg-gray-300 active:tw-text-gray-300 !tw-p-0 !tw-border-0';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;

        case 'white':
          result =
            'tw-border-white !tw-text-purple-600 tw-bg-white hover:tw-bg-gray-200 hover:tw-border-gray-200 active:tw-bg-gray-300 active:tw-border-gray-300 button button--white';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;

        case 'linkedin':
          result =
            '!tw-text-white tw-bg-linkedin tw-border-linkedin hover:tw-bg-btn-hover active:tw-bg-purple-900  hover:tw-border-btn-hover active:tw-border-purple-900';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          break;

        default:
          result =
            '!tw-text-white tw-bg-purple-600 tw-border-purple-600 button button--purple ';
          if (this.disabled) result += ' tw-opacity-30 !tw-cursor-default';
          else
            result +=
              ' hover:tw-bg-btn-hover hover:tw-border-btn-hover active:tw-bg-purple-900 active:tw-border-purple-900';
          break;
      }
      return result;
    },

    iconColor() {
      if (
        this.variant === 'outlined' ||
        this.variant === 'text' ||
        this.variant === 'white'
      ) {
        return '#5656B2';
      }
      return '#fff';
    },
  },

  methods: {
    onClick(evt) {
      if (!this.loading && !this.disabled) {
        this.$emit('click', evt);
      } else {
        evt.preventDefault();
      }
    },
  },
};
</script>
<style scoped>
.button {
  position: relative;
  border: none;
}

.button::before,
.button::after {
  position: absolute;
  top: 0;
  left: -10%;
  height: 100%;
}

.button > div {
  position: relative;
}

.button--purple {
  letter-spacing: 0.05rem;
  font-weight: 600;
  font-size: 1.125rem;
  border-radius: 8px;
  overflow: hidden;
  color: #fff;
  background: #7b7bc2;
}

.button--purple:hover::before {
  transform: translate3d(100%, 0, 0);
}

.button--purple::before {
  content: '';
  background: #5656b2;
  width: 120%;
  left: -10%;
  transform: skew(30deg);
  transition: transform 0.4s cubic-bezier(0.3, 1, 0.8, 1);
}

.button--grey {
  letter-spacing: 0.05rem;
  font-weight: 600;
  font-size: 1.125rem;
  border-radius: 8px;
  overflow: hidden;
  color: #fff;
  background: #757575;
}

.button--grey:hover::before {
  transform: translate3d(100%, 0, 0);
}

.button--grey::before {
  content: '';
  background: #424242;
  width: 120%;
  left: -10%;
  transform: skew(30deg);
  transition: transform 0.4s cubic-bezier(0.3, 1, 0.8, 1);
}

.button--white {
  letter-spacing: 0.05rem;
  font-weight: 600;
  font-size: 1.125rem;
  border-radius: 8px;
  overflow: hidden;
  color: #212121;
  background: #e8e8f7;
}

.button--white:hover::before {
  transform: translate3d(100%, 0, 0);
}

.button--white::before {
  content: '';
  background: #fff;
  width: 120%;
  left: -10%;
  transform: skew(30deg);
  transition: transform 0.4s cubic-bezier(0.3, 1, 0.8, 1);
}
</style>
